import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiContentService } from '../../../api/api-content.service';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert/dist/sweetalert.min.js';

import { jsPDF }  from 'jspdf';  
import autoTable from 'jspdf-autotable';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';

@Component({
  selector: 'app-pdf',
  templateUrl: './pdf.component.html',
  styleUrls: ['./pdf.component.css'],
  providers: [ DatePipe ]
})
export class PdfComponent implements OnInit {
  @ViewChild('content') content: ElementRef; 
  @ViewChild('modal1', { static:false }) modal1: ElementRef;
  // @ViewChild('modal1', {read: ElementRef}) private modal1: ElementRef;
  // @ViewChild('modal1', { read: ElementRef }) modal1: ElementRef;
  // @ViewChild('modal1') private modal1: any;
  @ViewChild('pdfTable') pdfTable: ElementRef;

  constructor(
    public rest: ApiContentService,
    public route: ActivatedRoute,
    public datepipe: DatePipe,
  ) { }

  dataimage:any = []
  dataall:any = []
  dataorder:any = []
  dataprospek:any = []
  errormsg:any = []

  notFound = false
  notAuth = false

  ngOnInit() {
    this.firstModal()
    localStorage.removeItem('currentUser');

    let params = this.route.snapshot.paramMap.get('encrypt')
    var decrypt = atob(params)
    decrypt = decrypt.replace('_xx_','+').replace('_mm_','/')
    var arrs = decrypt.split('_vv_')
    console.log(arrs)

    const data = {
      'data':{
        'access_token': arrs[2]
      }
    }
    localStorage.setItem('currentUser', JSON.stringify(data));
    this.getpdf(params)
  }

  private openModal(): void {
    // this.sidenavContainer._element.nativeElement
    this.modal1.nativeElement.click();
  }

  firstModal(){
    swal("Processing your request...", {
      buttons: false,
      closeOnClickOutside: false,
    })
  }

  getpdf(params:any){
    this.notFound = false
    this.notAuth = false
    this.rest.getdatapdf(params).subscribe((response:any) => {
      console.log(response)

      // setTimeout(() => {
      //   swal.close()
      // }, 500);
      if(response.status == false){
        swal.close()
        this.notAuth = true
        this.errormsg = response.message
      }else{

        if(response.data.prospek.length != 0){
          swal.close()
          this.dataall = response.data
          this.dataorder = response.data.order
          this.dataprospek = response.data.prospek
          this.dataimage = response.data.dataimage
          console.log(this.dataprospek)
          setTimeout(() => {
            this.openModal()
            
          }, 500);
        }else{
          swal.close()
          console.log("kosong")
          this.notFound = true
        }
      }
    })
  }

  public generate(value: any) {
    // playground requires you to assign document definition to a variable called dd
    // const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }
    // const tglpmsn = this.dataprospek.created_date.toLocaleString('id-ID', options)
    const tglpmsn = this.datepipe.transform(this.dataprospek.created_date, 'dd-MMM-yyyy HH:mm:ss')

    const body_order = []
    const body_image = []
    const images = []
    
    body_order[0] = [{text: '#', style: 't1font'}, {text: 'Tipe', style: 't1font'}, {text: 'Nama', style: 't1font'}, {text: 'Harga', style: 't1font', alignment: 'center'}]

    // const index = 0
    this.dataorder.forEach((row:any, index: any) => {
      const item = [{text: index+1, style: 't2font'}, {text: row.product_type_name, style: 't2font'}, {text: row.name, style: 't2font'}, {text: 'Rp.'+row.price.toLocaleString('id-ID'), style: 't3font'}]
      body_order.push(item)
    });

    this.dataall.bonus.forEach((row:any) => {
      const item = [{text: 'Bonus', style: 't1font', colSpan:2}, {text: '', style: 't2font'}, {text: row.name, style: 't2font'}, {text: 'Rp.'+row.price.toLocaleString('id-ID'), style: 't3font'}]
      body_order.push(item)
    });

    this.dataall.discount.forEach((row:any) => {
      const item = [{text: 'Diskon', style: 't1font', colSpan:2}, {text: '', style: 't2font'}, {text: row.name, style: 't2font', colSpan:2}, {text: '', style: 't3font'}]
      body_order.push(item)
    });

    body_order.push([{text: 'Sub Total (1 Bulan)', style: 't2font', alignment: 'right', colSpan:3}, {text: '', style: 't2font'}, {text: '', style: 't2font'}, {text: 'Rp.'+this.dataall.price_1mo.toLocaleString('id-ID'), style: 't3font'}])
    body_order.push([{text: 'Biaya Instalasi', style: 't2font', alignment: 'right', colSpan:3}, {text: '', style: 't2font'}, {text: '', style: 't2font'}, {text: 'Rp.'+this.dataall.installationfee.price_total.toLocaleString('id-ID'), style: 't3font'}])
    body_order.push([{text: 'Harga Sebelum PPN', style: 't2font', alignment: 'right', colSpan:3}, {text: '', style: 't2font'}, {text: '', style: 't2font'}, {text: 'Rp.'+this.dataall.price_before_ppn.toLocaleString('id-ID'), style: 't3font'}])
    body_order.push([{text: 'Biaya PPN', style: 't2font', alignment: 'right', colSpan:3}, {text: '', style: 't2font'}, {text: '', style: 't2font'}, {text: 'Rp.'+this.dataall.price_ppn.toLocaleString('id-ID'), style: 't3font'}])
    body_order.push([{text: 'Total Bayar', style: 't1font', alignment: 'right', colSpan:3}, {text: '', style: 't1font'}, {text: '', style: 't1font'}, {text: 'Rp.'+this.dataall.price_total.toLocaleString('id-ID'), style: 't3font', bold: true}])

    //pdf.addImage(v.imgUrlBase64, 0, 0, v.imgWidth, v.imgHeight)
    if(this.dataimage.image1 != null ){ images.push({image: this.dataimage.image1, fit: [100, 100]}) }
    if(this.dataimage.image2 != null ){ images.push({image: this.dataimage.image2, fit: [100, 100]}) }
    if(this.dataimage.image3 != null ){ images.push({image: this.dataimage.image3, fit: [100, 100]}) }
    if(this.dataimage.image4 != null ){ images.push({image: this.dataimage.image4, fit: [100, 100]}) }
    if(this.dataimage.image5 != null ){ images.push({image: this.dataimage.image5, fit: [100, 100]}) }
    if(this.dataimage.image6 != null ){ images.push({image: this.dataimage.image6, fit: [100, 100]}) }
    body_image.push(images)
    console.log(body_image) 

    const dd = {
      content: [

        {
          style: 'tableExample',
          table: {
            widths: ['auto','*'],
            body: [
              [
                {
                  image: 'data:image/png;base64,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',
                  // style: 'imgcenter',
                  fit: [110,110]
                },
                {text: 'E-Summary Prospek\n'+this.dataprospek.prospek_id, style: 'titlecenter'},
              ]
            ]
          },
          layout: 'noBorders'
        },


        {
          style: 'tableExample',
          table: {
            widths: ['*'],
            body: [
              [{text: 'Info Pemesanan', style:'titleheader'}],
              [
                {
                  margin: [8, 8, 8, 8],
                  table: {
                    widths: [170, 'auto', '*'],
                    body: [
                      [{text: 'Tanggal Pemesanan', style: 't1font'}, {text: ':', style: 't2font'}, {text: tglpmsn, style: 't2font'}],
                      [{text: 'Nama', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_identity.nama, style: 't2font'}],
                      [{text: 'Alamat', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_identity.address, style: 't2font'}],
                      [{text: 'Telepon', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_identity.celular_number, style: 't2font'}],
                      [{text: 'Email', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_identity.email, style: 't2font'}],
                    ]
                  },
                  layout: 'noBorders'
                }
              ],
            ]
          },
          layout: {
            fillColor: function (rowIndex) {
              return (rowIndex === 0) ? '#e3e3e3' : null;
            },
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 0;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#e3e3e3' : 'white';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#e3e3e3' : 'white';
            },
          }
        },

        {
          style: 'tableExample',
          table: {
            widths: ['*'],
            body: [
              [{text: 'Info Pemasangan', style:'titleheader'}],
              [
                {
                  margin: [8, 8, 8, 8],
                  table: {
                    widths: [170, 'auto', '*'],
                    body: [
                      [{text: 'Alamat Pemasangan', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_install.address, style: 't2font'}],
                      [{text: 'Atas Nama', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_install.nama, style: 't2font'}],
                      [{text: 'Telepon', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_install.celular_number, style: 't2font'}],
                      [{text: 'No. Meteran', style: 't1font'}, {text: ':', style: 't2font'}, {text: this.dataprospek.prospek_install.no_meteran, style: 't2font'}],
                    ]
                  },
                  layout: 'noBorders'
                }
              ],
            ]
          },
          layout: {
            fillColor: function (rowIndex) {
              return (rowIndex === 0) ? '#e3e3e3' : null;
            },
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 0;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#e3e3e3' : 'white';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#e3e3e3' : 'white';
            },
          }
        },

        {
          style: 'tableExample',
          table: {
            widths: ['*'],
            body: [
              [{text: 'Info Order', style:'titleheader'}],
              [
                {
                  margin: [8, 8, 8, 8],
                  table: {
                    widths: ['auto', 100, '*', 100],
                    body: body_order
                  },
                  layout: 'noBorders'
                }
              ],
            ]
          },
          layout: {
            fillColor: function (rowIndex) {
              return (rowIndex === 0) ? '#e3e3e3' : null;
            },
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 0;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#e3e3e3' : 'white';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#e3e3e3' : 'white';
            },
          }
        },

        {
          style: 'tableExample',
          table: {
            widths: ['*'],
            body: [
              [{text: 'Foto', style:'titleheader'}],
              [
                {
                  margin: [8, 8, 8, 8],
                  table: {
                    widths: [75,75,75,75,75,75],
                    body: body_image,
                  },
                  layout: 'noBorders'
                }
              ],
            ]
          },
          layout: {
            fillColor: function (rowIndex) {
              return (rowIndex === 0) ? '#e3e3e3' : null;
            },
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 0;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#e3e3e3' : 'white';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#e3e3e3' : 'white';
            },
          }
        },

      ],


      styles: {
        imgcenter: {
          margin: [0,0,0,0],
          alignment:'center',
          width: 15
        },
        titlecenter: {
          fontSize: 11,
          margin: [0,8,0,0],
          alignment:'right',
          bold: true
        },
        titleheader: {
          bold: true,
          fontSize: 10,
          color: 'black'
        },
        t1font: {
          bold: true,
          fontSize: 9
        },
        t2font: {
          fontSize: 9
        },
        t3font: {
          alignment: 'right',
          fontSize: 9
        },

        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 9,
          background: '#d6d6d6',
          color: 'black'
        },
      },
      defaultStyle: {
        // alignment: 'justify'
      }
      
    }
    if(value == 'download'){

      setTimeout(() => {
        var today = new Date();
        var dt = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); 
        var yyyy = today.getFullYear();
        var hh = today.getHours();
        var min = today.getMinutes();
        var sec = today.getSeconds();
        var datetime = dt + mm + yyyy + hh + min + sec;
        // console.log(datetime)

        pdfMake.createPdf(dd).download('Prospek_Summary_'+this.dataprospek.prospek_id+'_'+datetime)
        
      }, 500);

    }else{
      setTimeout(() => {
        pdfMake.createPdf(dd).open()
      }, 500);
    }

  }

}


